import { html } from '../../mixins/katapult-element';
import { KatapultEditorTemplate } from './katapult-editor-template';
import { IllegalCharacters, ContainsIllegalCharacters } from '../../modules/ContainsIllegalCharacters.js';

import '../katapult-elements/katapult-button.js';
import '../k-logic-editor/k-logic-editor.js';
import { capitalCase } from 'change-case';
import { Path } from '../../modules/Path.js';

class KatapultCompatibleUnitAutomationsEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      ${super.style}
      <style>
        .body {
          margin-left: 48px;
        }
        paper-tabs {
          --paper-tabs-selection-bar-color: var(--secondary-color);
          --paper-tab-ink: var(--secondary-color);
        }
        paper-tab {
          --paper-tab: {
            font-size: 12pt;
            font-weight: normal;
          };
          --paper-tab-content-focused: {
            font-weight: normal;
          };
        }

        paper-header-content {
          background-color: white;
          color: var(--paper-grey-800);
        }
        paper-header-content paper-input {
          text-transform: none;
        }

        [drag-handle]:hover {
          cursor: move;
        }

        paper-tabs {
          --paper-tabs-content: {
            display: flex;
            min-width: 100%;
          };
        }

        .dialog-option {
          min-width: 5.14em;
        }
      </style>
      <katapult-firebase-worker
        id="automationGroupingsFirebaseWorker"
        path="[[modelSpaceDetails.path]]/models/compatible_unit_models/automation_groupings"
        data="{{automationGroupings}}"
      >
      </katapult-firebase-worker>
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes" data="{{otherAttributes}}"> </katapult-firebase-worker>
      <katapult-dialog title="Logic Editor" id="kLogicEditor">
        <k-logic-editor block="{{automationLogic}}"></k-logic-editor>
        <div slot="buttons">
          <katapult-button dialog-dismiss>Cancel</katapult-button>
          <katapult-button color="var(--secondary-color)" dialog-confirm on-click="saveLogic">Save</katapult-button>
        </div>
      </katapult-dialog>
      <paper-dialog
        id="editAutomationGroupings"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
        no-cancel-on-outside-click=""
      >
        <div title secondary-color>Edit Automation Groupings</div>
        <div body>
          <paper-table style="overflow: hidden;" white outline rounded dividers>
            <paper-table-scroll on-sort-changed="automationGroupingsArraySortChanged">
              <template is="dom-repeat" items="[[automationGroupingsArray]]">
                <paper-row slot="sortable" item="[[item]]">
                  <paper-cell style="background-color:white;">
                    <iron-icon icon="katapult-misc:drag-indicator"></iron-icon>
                    <div style="flex-grow:1; white-space: nowrap;">[[item.name]]</div>
                    <katapult-button iconOnly noBorder icon="delete" on-click="removeAutomationGrouping"></katapult-button>
                  </paper-cell>
                </paper-row>
              </template>
            </paper-table-scroll>
          </paper-table>
          <paper-row>
            <paper-cell>
              <paper-input
                id="newAutomationGroupingNameInput"
                label="New Automation Grouping"
                value="{{newAutomationGroupingName}}"
                autofocus
                no-label-float
              ></paper-input>
            </paper-cell>
            <paper-cell icon-button>
              <katapult-button
                iconOnly
                noBorder
                color="var(--secondary-color)"
                icon="add"
                on-click="addNewAutomationGrouping"
                style="border-radius: 999px"
              ></katapult-button>
            </paper-cell>
          </paper-row>
        </div>
        <div buttons>
          <katapult-button dialog-dismiss>Close</katapult-button>
        </div>
      </paper-dialog>

      <template is="dom-repeat" items="[[steps]]" as="step">
        <katapult-editor-step
          step$="[[step.id]]"
          creating-item="[[creatingItem]]"
          active="[[step.active]]"
          index="[[step.index]]"
          current-index="[[currentIndex]]"
          title="[[step.title]]"
        >
          <template is="dom-if" if="[[equal(step.id, 'tag')]]" restamp>
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input label="Insert a Tag" value="{{_itemData.tag}}" no-label-float disabled="[[!fullyEditable]]"></paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button slot="current-step-body" on-click="nextStep" class="dialog-option" style="margin-left: 16px"
              >Skip</katapult-button
            >
          </template>

          <template is="dom-if" if="[[equal(step.id, 'type')]]" restamp>
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <katapult-drop-down
                    items="[[cuAutomationTypes]]"
                    label-path="label"
                    value-path="value"
                    label="Select Compatible Unit Automation Type"
                    value="{{_itemData.type}}"
                    null-value="[[null]]"
                    no-label-float
                  ></katapult-drop-down>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button slot="current-step-body" on-click="nextStep" class="dialog-option" style="margin-left: 16px"
              >Skip</katapult-button
            >
          </template>

          <template is="dom-if" if="[[equal(step.id, 'marker_type')]]" restamp>
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <katapult-drop-down
                    items="[[markerTypes]]"
                    label-path="label"
                    value-path="value"
                    label="Select Marker Type"
                    value="{{_itemData.marker_type}}"
                    null-value="[[null]]"
                    no-label-float
                  ></katapult-drop-down>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button slot="current-step-body" on-click="nextStep" class="dialog-option" style="margin-left: 16px"
              >Skip</katapult-button
            >
          </template>

          <template is="dom-if" if="[[equal(step.id, 'marker_type_spec')]]" restamp>
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <template is="dom-if" if="[[markerTypeSpecValues]]">
                    <katapult-drop-down
                      items="[[markerTypeSpecValues]]"
                      label="Select Sub Type"
                      null-value="[[null]]"
                      value="[[markerTypeSpecValue]]"
                      no-label-float
                      on-value-changed="setMarkerTypeSpec"
                    ></katapult-drop-down>
                  </template>
                  <template is="dom-if" if="[[!markerTypeSpecValues]]">
                    <span>Please select a marker type</span>
                  </template>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button slot="current-step-body" on-click="nextStep" class="dialog-option" style="margin-left: 16px"
              >Skip</katapult-button
            >
          </template>

          <template is="dom-if" if="[[equal(step.id, 'automation_groupings')]]" restamp>
            <katapult-button slot="current-step-body" on-click="nextStep" class="dialog-option" style="margin-left: 16px"
              >Skip</katapult-button
            >
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <katapult-drop-down
                    items="[[automationGroupings]]"
                    label-path="name"
                    value-path="name"
                    label="Select an Automation Grouping"
                    value="{{_itemData.grouping}}"
                    no-label-float
                  >
                    <paper-item on-click="editAutomationGroupings">EDIT AUTOMATION GROUPINGS</paper-item>
                  </katapult-drop-down>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'logic')]]" restamp>
            <katapult-button slot="current-step-body" on-click="nextStep" class="dialog-option" style="margin-left: 16px"
              >Skip</katapult-button
            >
            <katapult-button
              iconOnly
              noBorder
              color="var(--paper-teal-800)"
              icon="functions"
              on-click="openLogicEditor"
              slot="body"
            ></katapult-button>
          </template>
        </katapult-editor-step>
      </template>
      ${super.createItemContainer}
    `;
  }

  static get properties() {
    return {
      cuAutomationTypes: {
        type: Array,
        value: [
          { label: 'Node', value: 'node' },
          { label: 'Marker', value: 'marker' }
        ]
      },
      markerTypes: {
        type: Array,
        value: [
          { label: 'Wire', value: 'wire' },
          { label: 'Equipment', value: 'equipment' },
          { label: 'Guying', value: 'guying' },
          { label: 'Pole Top', value: 'pole_top' }
        ]
      },
      markerTypeToSpecMapping: {
        type: Object,
        value: {
          wire: 'cable_type',
          equipment: 'equipment_type',
          guying: 'guying_type'
        }
      },
      markerTypeSpecValues: {
        type: Object,
        value: null
      },
      null: {
        type: Object,
        value: null
      },
      oldMarkerType: {
        type: String,
        computed: `getOldMarkerType(_itemData)`
      }
    };
  }

  static get observers() {
    return [
      'updateAutomationGroupingsArray(automationGroupings.*)',
      'markerTypeChanged(_itemData.marker_type)',
      'clearLogicEditor(itemKey)'
    ];
  }

  ready() {
    super.ready();
    // An ordered list of all possible steps.
    this.setSteps([
      {
        id: 'tag',
        title: 'Tag',
        trigger: () => this.get('_itemData.tag') != null
      },
      {
        id: 'type',
        title: 'Type',
        trigger: () => this.get('_itemData.type') != null
      },
      {
        id: 'marker_type',
        title: 'Marker Type',
        trigger: () => this.get('_itemData.marker_type') != null
      },
      {
        id: 'marker_type_spec',
        title: 'Secondary Type',
        trigger: () => this.get(`_itemData.${this.markerTypeSpec}`) != null
      },
      {
        id: 'automation_groupings',
        title: 'Grouping',
        trigger: () => this.get('_itemData.grouping') != null
      },
      {
        id: 'logic',
        title: 'Logic',
        trigger: () => this.get('_itemData.logic') !== undefined
      }
    ]);
  }

  labelChanged(label) {
    this.set('_itemData.name', label);
  }

  getOldMarkerType() {
    return this._itemData?.marker_type;
  }

  saveLogic() {
    // delete the hide attribute before saving
    delete this.automationLogic._hide;
    // set the logic on the item data
    let currentItemData = this._itemData;
    currentItemData.logic = this.automationLogic;
    this.set('_itemData', { ...currentItemData });
  }

  openLogicEditor() {
    let automationLogic = this._itemData.logic;
    if (automationLogic) automationLogic._hide = true;
    this.automationLogic = automationLogic;
    this.$.kLogicEditor.open();
  }

  clearLogicEditor() {
    this.automationLogic = null;
  }

  setMarkerTypeSpec(e) {
    let markerSpecTypeValue = e.detail.value;
    if (markerSpecTypeValue) {
      // set the marker type spec value on item data using the marker type spec
      let currentItemData = this._itemData;
      currentItemData[this.markerTypeSpec] = markerSpecTypeValue;
      this.set(`_itemData`, { ...currentItemData });
    }
  }

  markerTypeChanged(e) {
    let markerType = Path.copy(this._itemData?.marker_type);
    // get the marker spec type
    this.markerTypeSpec = this.markerTypeToSpecMapping[markerType];
    // set the markerTypeSpec value (which is what shows up in the dropdown below "Marker Type")
    this.markerTypeSpecValue = this._itemData?.[this.markerTypeSpec];
    if (markerType) {
      // if we have a marker spec type, change the step name to the type
      if (this.markerTypeSpec) {
        // set the step name of the marker type spec step
        let newSteps = Path.copy(this.steps);
        let indexOfMarkerTypeSpec = newSteps.findIndex((step) => step.id === 'marker_type_spec');
        if (indexOfMarkerTypeSpec != -1) {
          newSteps[indexOfMarkerTypeSpec].title = capitalCase(this.markerTypeSpec);
          this.set('steps', newSteps);
        }

        // get the old spec value
        let oldMarkerTypeSpec = this.markerTypeToSpecMapping[this.oldMarkerType];
        // delete the old spec value from the item data
        if (oldMarkerTypeSpec && oldMarkerTypeSpec != this.markerTypeSpec) {
          let currentItemData = Path.copy(this._itemData);
          delete currentItemData[oldMarkerTypeSpec];
          this.set(`_itemData`, currentItemData);
          // set the old marker type
          this.oldMarkerType = markerType;
        }
      }

      // if the marker type is pole, remove the marker spec type from the steps
      if (markerType === 'pole_top') {
        let newSteps = Path.copy(this.steps);
        let indexOfMarkerTypeSpec = newSteps.findIndex((step) => step.id === 'marker_type_spec');
        if (indexOfMarkerTypeSpec != -1) {
          newSteps.splice(indexOfMarkerTypeSpec, 1);
          this.set('steps', newSteps);
        }
      }
      // add it back in if it's not
      else {
        let newSteps = Path.copy(this.steps);
        // add the it back only if it's not already there
        if (newSteps.findIndex((step) => step.id === 'marker_type_spec') == -1) {
          let markerTypeSpecStep = {
            id: 'marker_type_spec',
            title: capitalCase(this.markerTypeSpec || 'Secondary Type'),
            trigger: () => this.get(`_itemData.${this.markerTypeSpec}`) != null
          };
          newSteps.splice(3, 0, markerTypeSpecStep);
          this.set('steps', newSteps);
        }
      }

      // setup the marker type spec array based on the marker type spec
      if (!this.markerTypeSpec) return;
      // get an array of all of the picklist values for the spec
      let markerTypeSpecData = this.otherAttributes[this.markerTypeSpec];
      let specPicklists = markerTypeSpecData?.picklists;
      if (!specPicklists) return;
      let markerTypeSpecValues = this.getMarkerTypeSpecValues(specPicklists);
      if (!markerTypeSpecValues) return;
      // sort and set the spec array
      this.markerTypeSpecValues = markerTypeSpecValues.sort();
    }
  }

  getMarkerTypeSpecValues(picklists) {
    //  combine all of the data in every picklist into one array
    let markerTypeSpecValues = [];
    for (let picklist of Object.values(picklists)) {
      // skip items in the picklist that aren't arrays
      if (!Array.isArray(picklist)) continue;
      // map the picklist to just be the values
      let values = picklist.map((item) => item.value);
      // add the values to the spec array
      markerTypeSpecValues = [...markerTypeSpecValues, ...values];
    }
    return markerTypeSpecValues;
  }

  addNewAutomationGrouping() {
    let sanitized = (this.newAutomationGroupingName || '').trim();
    let exists = sanitized.length > 0;
    let illegal = ContainsIllegalCharacters(sanitized);
    let error = !exists
      ? 'Your attribute group must have a name'
      : illegal
        ? `You may not use the following characters: ${IllegalCharacters.join(' ')}`
        : null;
    this.$.newAutomationGroupingNameInput.errorMessage = error;
    this.$.newAutomationGroupingNameInput.invalid = error != null;
    if (error == null) {
      // create a firebase key for this new group
      let newKey = this.$.automationGroupingsFirebaseWorker._ref.push().key;
      // add the new automation grouping to the array and save it to firebase
      this.automationGroupingsArray.push({ $key: newKey, name: sanitized });
      this.saveAutomationGroupings();
      this.newAutomationGroupingName = '';
    }
  }
  async removeAutomationGrouping(e) {
    await this.$.automationGroupingsFirebaseWorker._ref.child(e.model.item.$key).remove();
  }

  automationGroupingsArraySortChanged(e) {
    let removedItem = this.automationGroupingsArray.splice(e.detail.prevIndex, 1)[0];
    this.automationGroupingsArray.splice(e.detail.index, 0, removedItem);
    this.notifySplices(`automationGroupingsArray`, [
      { index: e.detail.prevIndex, removed: [removedItem], addedCount: 0 },
      { index: e.detail.index, removed: [], addedCount: 1 }
    ]);
    this.saveAutomationGroupings();
  }

  editAutomationGroupings(e) {
    e.currentTarget.parentElement.close();
    this.$.editAutomationGroupings.open();
  }

  async saveAutomationGroupings() {
    let update = {};
    this.automationGroupingsArray.forEach((item, i) => {
      update[item.$key] = { name: item.name, priority: i };
    });
    await this.$.automationGroupingsFirebaseWorker._ref.update(update);
  }

  updateAutomationGroupingsArray() {
    if (!this.automationGroupings) return;
    // turn auotmationGroupings into an array and sort it by priority
    let automationGroupingsArray = Object.entries(this.automationGroupings).map(([groupingKey, groupingData]) => {
      groupingData.$key = groupingKey;
      return groupingData;
    });
    let sortedAutomationGroupings = automationGroupingsArray.sort((a, b) => a.priority - b.priority);
    this.automationGroupingsArray = sortedAutomationGroupings;
  }
}

customElements.define('katapult-compatible-unit-automations-editor', KatapultCompatibleUnitAutomationsEditor);
